// @ts-nocheck
import { IdeptInfo } from "../types";

export function removeDataByValue(
  data: IdeptInfo[] | IdeptInfo,
  key: string,
  value: string | number
) {
  if (Array.isArray(data)) {
    return data
      .map((item) => removeDataByValue(item, key, value))
      .filter((item) => item !== undefined);
  } else if (typeof data === "object") {
    if (data && data[key] === value) {
      return undefined;
    }
    if (!data) return data;
    const newData = {};
    for (let prop in data) {
      if (data.hasOwnProperty(prop)) {
        newData[prop] = removeDataByValue(data[prop], key, value);
      }
    }
    return newData;
  }
  return data;
}

export function getObjectAllValues(obj, key, value, targetKey) {
  let result = [];

  if (Array.isArray(obj)) {
    for (let i = 0; i < obj.length; i++) {
      const res = getObjectAllValues(obj[i], key, value, targetKey);
      result = result.concat(res);
    }
  } else if (typeof obj === "object") {
    for (let prop in obj) {
      if (prop === key && obj[prop] === value) {
        result.push(obj[targetKey]);
      } else {
        const res = getObjectAllValues(obj[prop], key, value, targetKey);
        result = result.concat(res);
      }
    }
  }

  return result;
}

export function getObjectValue(obj, key, value) {
  if (typeof obj !== "object" || obj === null) {
    return undefined;
  }
  if (
    `${obj[key[0]]}` === `${value[0]}` &&
    `${obj[key[1]]}` === `${value[1]}`
  ) {
    return obj;
  }
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      var nestedObj = getObjectValue(obj[prop], key, value);
      if (nestedObj !== undefined) {
        return nestedObj;
      }
    }
  }

  return undefined;
}

export function setObjectValue(obj, key, value, newItem) {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }
  if (`${obj[key]}` === `${value}`) {
    obj.deptList.push(newItem);
    return obj;
  }
  for (let prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      obj[prop] = setObjectValue(obj[prop], key, value, newItem);
    }
  }
  return obj;
}

export function makeUpSubmitArr(
  data: IdeptInfo[],
  currentDeptId?: string | number
) {
  let dataList: (IdeptInfo & {
    title: string;
    key: number;
    realDeptId: string;
    children?: any[];
  })[] = [];
  data.forEach((item) => {
    dataList.push(
      Object.assign(item, {
        realDeptId: item.deptId ?? currentDeptId,
        disabled: !!item.isExist,
        children: item.deptList.length
          ? makeUpSubmitArr(item.deptList, item.deptId ?? "")
          : [],
      })
    );
  });

  return dataList;
}
